import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import { parseQs } from 'helpers/http';

import List from 'components/List';

import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';
import ListFilterCompany from 'components/layout/list/filters/ListFilterCompany';
import ListFilterReset from 'components/layout/list/ListFilterReset';

import CommissionServiceInvoicesList from 'components/layout/financial/CommissionServiceInvoicesList';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

import may from 'js/security';
import { ROLE_ROOT_EMPLOYEE } from 'js/constants';
import {Button} from "react-bootstrap";
import Axios from "axios";
import {confirmAlert} from "react-confirm-alert";

class CommissionServiceInvoices extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      printing: false,
    };
  }

  handleRowClick = invoice => {
    const { appIntl, history } = this.props;
    history.push(appIntl.urlPrefix + 'account/settings/commissionServiceInvoices/' + invoice.id);
  };

  getInvoices = (e) => {
    const {intl: { messages }} = this.props;
    this.setState({ printing: true });
    let FileDownload;
    FileDownload = require('js-file-download');
    Axios({
      url: '/api/commissions/sales/list.json?offset=0&limit=50&search=&sort=cdate&dir=desc&page=1&_locale=de&csv=commissions', //your url
      method: 'GET',
      responseType: 'blob',
    })

      // Axios.get('/api/invoices.json?offset=0&limit=50&search=&sort=cdate&dir=desc&page=1&_locale=de&csv=invoices', {})
      .then((response) => {

        FileDownload(response.data, 'invoice.csv');
        this.setState({ printing: false}, () => {
          const options = {
            customUI: ({ onClose }) => {
              return (
                <div className='react-confirm-alert-body'>
                  <h1>{messages.salesDoc.download_csv_ready}</h1>
                  <div className="react-confirm-alert-button-group" style={{ width: "100%", margin: "0 auto" }}>
                    <Button style={{ margin: "0 auto", marginTop: "20px", width: "100px" }} bsStyle="primary" onClick={onClose}>OK</Button>
                  </div>
                </div>
              );
            },
            childrenElement: () => <div />,
            closeOnEscape: true,
            closeOnClickOutside: true,
          };
          confirmAlert(options);
        });

      })
      .catch((error) => {
        // handle error
        if (Axios.isCancel(error)) {
          console.log("post Request canceled");
        } else {
          console.log(error);
        }
      });
  }

  getBreadcrumb = () => {
    const {
      intl: { messages },
      appIntl,
    } = this.props;



    return (
      <Breadcrumb
        crumbs={[
          { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
          { link: appIntl.urlPrefix + 'account/settings', name: messages.settings },
          { link: null, name: messages.commission_service_documents },
        ]}
        className="p-t-0"
      />
    );
  };

  render() {
    const {
      intl: { messages },
      list,
      user,
      location,
    } = this.props;

    const { printing } = this.state;

    const query = parseQs(location.search);

    const urlData = {
      filters: {
        target: query.target,
      },
    };

    const filters = [];
    if (may(ROLE_ROOT_EMPLOYEE, user.roles)) {
      filters.push(<ListFilterCompany key="target" />);
      filters.push(<ListFilterReset key="reset-all" availableFilters={['target']} />);
    }
    // filters.push(<ListFilterInvoiceDirection key="doc-direction-filter" />);



    return (
      <DocMeta tags={generateMetaTags(messages.meta.commissionServiceDocuments)}>
        <List
          listName="commissionServiceInvoices"
          url="/api/commissions/sales/list.json"
          urlData={urlData}
          list={list}
          title={messages.commission_service_documents}
          iconClass="fal fa-file-alt"
          showNew={false}
          newAction={null}
          showSearch
          sortOptions={['cdate,desc']}
          breadcrumb={this.getBreadcrumb()}
          filters={filters}
        >
          {may(ROLE_ROOT_EMPLOYEE, user.roles) ?
            <Button bsStyle="default" onClick={() => this.getInvoices()}>

              <p style={{margin:"0"}} >
                {printing ?
                  <i className="far fa-spin fa-spinner-third"/> : null}
                <span>{messages.provision_service_documents_download}</span></p>
            </Button>
            :<></>
          }

          {list.pending ? (
            <Loader />
          ) : (
            <CommissionServiceInvoicesList list={list.data.list} showDetailsAction={this.handleRowClick} listName="commissionServiceInvoices" />
          )}
        </List>
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.commissionServiceInvoices,
    user: state.login.user,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(CommissionServiceInvoices)));
